"use client";

import React from "react";

function ImageMarquee({ items, speedSeconds = 97, className = "" }) {
    const marqueeItems = [...items, ...items];

    return (
        <div className={`w-full overflow-hidden ${className}`}>
            <div
                className="flex gap-5 marquee overflow-hidden"
                style={{ "--speed": `${speedSeconds}s` }}
            >
                {marqueeItems.map((item, index) => (
                    <div
                        key={index}
                        className="min-w-[250px] md:min-w-[320px] lg:min-w-[500px] relative overflow-hidden 
                         group transition-transform duration-700 hover:scale-105"
                    >
                        <div className="relative w-full h-[300px] md:h-[280px] lg:h-[360px]">
                            <img
                                src={typeof item.img === "string" ? item.img : item.img.src}
                                alt={item.alt}
                                width={500}
                                height={300}
                                className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110"
                            />
                            {/* Black overlay with white text */}
                            <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-all duration-700 flex items-end p-6">
                                <div className="w-full">
                                    {/* <h3 className="text-white text-lg md:text-xl lg:text-2xl font-bold mb-1 drop-shadow-lg">
                                        {item.title || item.alt}
                                    </h3> */}
                                    <p className="text-white/90 text-sm md:text-base drop-shadow-md">
                                        {item.description || ''}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ImageMarquee;
